import { Component, Input } from '@angular/core';
import { LookUpResourceModel } from 'src/app/section-wise/models/lookup-resource.model';

@Component({
  selector: 'other-detail-sw, [otherDetailSw]',
  templateUrl: './other-detail-sw.component.html'
})
export class OtherDetailSwComponent {
  isActive = false;
  @Input() otherDetail: Array<LookUpResourceModel>;

  constructor() {}

  toggleActive(): void {
    this.isActive = !this.isActive;
  }
}
